// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2qS6v","insightsList":"newBusinessInsightsMenu_insightsList__AfuBM","active":"newBusinessInsightsMenu_active__1FSLc"};